<template>
  <div class="container">
    <div class="header">
      <Loader v-if="loadingMoreSurveys || loading" :size="17" />

      <h2>{{ parseTranslation(RECENT_SURVEYS) }}</h2>
    </div>

    <div>
      <div style="margin-bottom: 10px">
        <el-row>
          <el-col class="searchDatatable">
            <div class="refreshSelect">
              <button class="btn-refresh" @click="refresh" :disabled="loading">
                <img class="img-refresh" src="@/assets/imgs/refresh.svg" alt="Refresh" />
              </button>

              <select
                v-if="$store.getters.accType === 'Root'"
                id="group"
                name="group"
                v-model="groupName"
                :disabled="loading"
              >
                <option
                  v-for="(group, index) in groups"
                  :key="index"
                  :value="group.group_name"
                >
                  {{ group.group_name }}
                </option>
              </select>
            </div>

            <div class="search">
              <el-input
                :class="{
                  light: !$store.getters.darkmode,
                }"
                :placeholder="translations[language][SEARCH_NAME]"
                :disabled="loading"
                v-model="filters[0].value"
              ></el-input>
              <img class="magnifier" src="@/assets/imgs/magnifier.svg" />
            </div>
          </el-col>
        </el-row>
      </div>

      <div v-if="!loading" class="scroll">
        <data-tables
          :data="data"
          :filters="filters"
          :current-page="1"
          :page-size="10"
          :pagination-props="{ background: true, pageSizes: [10, 20, 50, 100] }"
          :class="{
            light: !$store.getters.darkmode,
          }"
          class="data-table"
          v-if="!loading"
        >
          <el-table-column label="">
            <template slot-scope="scope">
              <el-button
                :class="{
                  left: !scope.row.activated,
                }"
                class="toggle"
                type="text"
                @click="() => handleButtonActivationToggle(scope.row)"
                v-if="!activationLoadingStatus[scope.row.id_]"
              >
                {{ scope.row.activated ? 'ON' : 'OFF' }}
              </el-button>

              <div v-else class="activation-loader">
                <Loader :size="20" />
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="name"
            :label="translations[language][NAME]"
            key="name"
            min-width="150px"
            sortable
          >
          </el-table-column>

          <el-table-column
            prop="created"
            :label="translations[language][CREATED]"
            key="created"
            :formatter="formatterDate"
            sortable
            min-width="90px"
          >
          </el-table-column>

          <el-table-column label="">
            <template slot-scope="scope">
              <el-button
                :class="{
                  active: scope.row.activated,
                }"
                class="btn-survey edit"
                v-for="button in customButtonsEdit(scope.row)"
                :key="button.name"
                type="text"
                @click="button.handler"
              >
                <div class="content">
                  <Edit />

                  {{ button.name }}
                </div>
              </el-button>
            </template>
          </el-table-column>

          <el-table-column label="" min-width="130px">
            <template slot-scope="scope">
              <el-button
                :class="{ disabled: !scope.row.canBeTested }"
                class="btn-survey test-survey"
                v-for="button in customButtonsTestSurvey(scope.row)"
                :key="button.name"
                type="text"
                @click="button.handler"
              >
                <div class="content">
                  <Eye />

                  {{ button.name }}
                </div>
              </el-button>
            </template>
          </el-table-column>

          <el-table-column label="" min-width="110px">
            <template slot-scope="scope">
              <el-button
                :class="{
                  active: !scope.row.activated,
                }"
                class="btn-survey sample-quotas"
                v-for="button in customButtonsOWSample(scope.row)"
                :key="button.name"
                type="text"
                @click="button.handler"
              >
                <div class="content">
                  <Out />

                  {{ button.name }}
                </div>
              </el-button>
            </template>
          </el-table-column>

          <el-table-column label="" min-width="70px">
            <template slot-scope="scope">
              <button
                v-for="button in customButtonsReport(scope.row)"
                :key="button.name"
                type="text"
                class="btn-survey report"
                @click="button.handler"
                :disabled="!scope.row.hasReport"
              >
                <div class="content">
                  <Report />
                  {{ button.name }}
                </div>
              </button>
            </template>
          </el-table-column>

          <el-table-column label="">
            <template slot-scope="scope">
              <div :id="`menu${scope.row.id_}`" class="menu-survey-table">
                <button @click="handleDrop(scope)" class="menu launch">
                  <DotsMenu />
                </button>

                <div :id="`drop${scope.row.id_}`" class="menu-dropdown">
                  <button
                    :class="{
                      active: !scope.row.activated,
                    }"
                    class="agentAndPartner"
                    v-for="button in customButtonsType(scope.row)"
                    :key="button.name"
                    @click="button.handler"
                  >
                    <Out />
                    {{ button.name }}
                  </button>

                  <button
                    type="button"
                    @click="openModalClone(scope.row.id_, scope.row.name)"
                  >
                    <Copy />
                    {{ parseTranslation(CLONE_SURVEY) }}
                  </button>

                  <button @click="openModalProperties(scope.row)" type="button">
                    <Info />
                    {{ parseTranslation(SURVEY_PROPERTIES) }}
                  </button>

                  <button @click="openModalDelete(scope.row.id_, scope.row.name)">
                    <Delete />
                    <p>{{ parseTranslation(DELETE) }}</p>
                  </button>
                </div>
              </div>
            </template>
          </el-table-column>
        </data-tables>
      </div>

      <div class="first-loading-wrapper" v-else>
        <div
          class="shimmer"
          v-for="shimmer in Array.from({ length: 16 }, (_, index) => `shimmer-${index}`)"
          :key="shimmer"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import Loader from '@/components/loading/Loader-4'

import DotsMenu from '@/components/imgs/DotsMenu'
import Out from '@/components/imgs/Out'
import Delete from '@/components/imgs/Delete'
import Info from '@/components/imgs/Info'
import Copy from '@/components/imgs/Copy'
import Edit from '@/components/imgs/Edit'
import Eye from '@/components/imgs/Eye'
import Report from '@/components/imgs/Report'

import { SURVEY_TYPE } from '@/utils/constants'

import * as translationSurveyDataTable from './SurveyDataTable.translations'

const { default: translations, ...translationKeys } = translationSurveyDataTable

export default {
  components: {
    DotsMenu,
    Out,
    Delete,
    Info,
    Copy,
    Edit,
    Eye,
    Report,

    Loader,
  },

  data() {
    return {
      translations,
      ...translationKeys,

      loading: false,
      loadingMoreSurveys: false,
      validPartner: true,
      activationLoadingStatus: {},

      groupName: this.$store.getters.groupName,
      groups: '',

      data: [],

      titles: [
        {
          prop: 'name',
          label: 'Name',
        },
        {
          prop: 'created',
          label: 'Created',
        },
      ],

      filters: [
        {
          prop: 'name',
          value: '',
          filterFn: (survey, { value }) => {
            const { id_, name } = survey

            const lookForId = id_.length === value.length
            const propsToMatch = lookForId ? [id_, name] : [name]

            const isMatch = propsToMatch.some(prop =>
              prop.toLowerCase().includes(value.toLowerCase()),
            )

            return isMatch
          },
        },
      ],
      url: '',
    }
  },

  watch: {
    groupName() {
      this.$store.dispatch('groupName', this.groupName)
      this.loadSurveys()
    },
  },

  methods: {
    ...mapActions([
      'modalBtns',
      'sendMessage',
      'surveyRemove',
      'modalProperties',
      'surveyRegister',
      'executeSurveyAPICall',
      'modalClone',
      'setLoading',
    ]),

    sortGroupsInAlphabeticalOrder(groups) {
      const orderNameGroupReturn = groups
        .slice()
        .sort((a, b) => a.group_name.localeCompare(b.group_name))

      return orderNameGroupReturn
    },

    async getGroups() {
      if (!this.$store.getters.accType === 'Root') return

      const groups = await this.executeSurveyAPICall({
        path: 'groups/list',
      })

      if (!groups) return

      this.groups = this.sortGroupsInAlphabeticalOrder(groups)
    },

    refresh() {
      this.data = []
      this.loadSurveys()
    },

    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },

    changeDateFormat(inputDate) {
      const splitDate = inputDate.split('-')
      if (splitDate.count === 0) {
        return null
      }

      const [year, month, day] = splitDate

      return `${month}/${day}/${year}`
    },

    formatterDate(row) {
      const [date] = row.created.split(' ')
      return this.changeDateFormat(date)
    },

    handleButtonActivationToggle(row) {
      this.openModalBtns(row.id_, row.activated, row.name)
    },

    customButtonsEdit(row) {
      return [
        {
          name: this.parseTranslation(this.EDIT),
          handler: _ => {
            this.loadSurvey(row.id_, row.activated)
          },
        },
      ]
    },

    customButtonsTestSurvey(row) {
      return [
        {
          name: this.parseTranslation(this.TEST_SURVEY),
          handler: _ => {
            this.openTestLink(row)
          },
        },
      ]
    },

    customButtonsReport(row) {
      return [
        {
          name: 'Report',
          handler: _ => {
            if (!row.hasReport) return

            this.$router.push({ name: 'report', query: { survey: row.id_ } })
          },
        },
      ]
    },

    customButtonsOWSample(row) {
      return [
        {
          name: `Sample/${this.parseTranslation(this.QUOTAS)}`,
          handler: _ => {
            if (row.activated) {
              this.$router.push({ name: 'quota', query: { survey: row.id_ } })
            }
          },
        },
      ]
    },

    customButtonsType(row) {
      return [
        {
          name:
            row.survey_type === 'CATI' || row.survey_type === 'CAPI'
              ? this.translations[this.language][this.ADD_AGENT]
              : this.translations[this.language][this.PARTNER_LINK],
          handler: _ => {
            if (row.survey_type === 'CATI' || row.survey_type === 'CAPI')
              this.goToAgent(row.id_, row.activated)
            else this.goToPartners(row.id_, row.activated)
          },
        },
      ]
    },

    goToPartners(SurveyId, activated) {
      if (!activated) return
      this.$router.push({ name: 'addpartner', query: { surveyId: SurveyId } })
    },

    goToAgent(SurveyId, activated) {
      if (!activated) return

      this.$router.push({ name: 'addagent', query: { surveyId: SurveyId } })
    },

    openModalBtns(survey_id, currentStatus, name) {
      const modalWarning = currentStatus

      this.modalBtns({
        text: currentStatus
          ? this.parseTranslation(this.PAUSING_SURVEY, name)
          : this.parseTranslation(this.START_FIELD, name),
        yes: this.changeActivationStatus,
        params: { survey_id, newStatus: !currentStatus, modalWarning },
      })
    },

    toggleActivationLoadingToSurvey(id) {
      const current = this.activationLoadingStatus[id]

      this.activationLoadingStatus = {
        ...this.activationLoadingStatus,
        [id]: !current,
      }
    },

    async changeActivationStatus({ survey_id, newStatus }) {
      this.toggleActivationLoadingToSurvey(survey_id)

      const actionPath = newStatus ? 'activate' : 'deactivate'

      const success = await this.executeSurveyAPICall({
        method: 'POST',
        path: `survey/${actionPath}`,
        payload: { survey_id },
      })

      if (!success) return this.toggleActivationLoadingToSurvey(survey_id)

      this.updateSurveysWithNewActivationStatus({
        survey_id,
        newStatus: newStatus,
      })

      const translations = this.translations[this.language]

      const newValue = newStatus ? this.ACTIVATED : this.DEACTIVATED

      this.sendMessage(
        `${translations[this.SURVEY]} ${translations[newValue]} ${
          translations[this.CHANGE_STATUS_SUCCESS]
        }`,
      )

      this.toggleActivationLoadingToSurvey(survey_id)
    },

    updateSurveysWithNewActivationStatus({ survey_id, newStatus }) {
      this.data = this.data.map(survey => {
        if (survey.id_ !== survey_id) return survey

        return {
          ...survey,
          activated: newStatus,
          hasReport: true,
        }
      })
    },

    openModalDelete(id, name) {
      this.modalBtns({
        text: this.parseTranslation(this.DELETE_MESSAGE, name),
        yes: this.deleteSurvey,
        params: { id },
      })
    },

    async deleteSurvey({ id: survey_id }) {
      this.turnLoadingOn()

      const success = await this.executeSurveyAPICall({
        method: 'DELETE',
        path: 'survey',
        payload: { survey_id },
      })

      if (!success) return this.turnLoadingOff()

      if (this.$store.getters.hasSurvey && this.$store.getters.name === survey_id) {
        this.surveyRemove()
      }

      this.removeSurveyFromList(survey_id)

      this.sendMessage(this.translations[this.language][this.SURVEY_DELETED])

      this.turnLoadingOff()
    },

    removeSurveyFromList(surveyId) {
      this.data = this.data.filter(({ id_ }) => id_ !== surveyId)
    },

    openModalProperties(row) {
      this.modalProperties({
        info: row,
      })
    },

    report(surveyName, surveyId) {
      window.open(
        `${this.reporttool}?token=${this.$store.getters.token}&surveyId=${surveyId}&surveyName=${surveyName}`,
        '_blank',
      )
    },

    openModalClone(rowId, nameSurvey) {
      this.modalClone({ rowId: rowId, nameSurvey: nameSurvey })
    },

    async loadSurvey(survey_id, activated) {
      if (activated) return

      this.setLoading(true)

      const survey = await this.executeSurveyAPICall({
        path: 'survey',
        queryParams: { survey_id },
      })

      if (!survey) return this.setLoading(false)

      this.surveyRegister(survey)

      await this.$router.push(`/${survey.step}`)

      this.setLoading(false)
    },

    async openTestLink(row) {
      if (!row.canBeTested) return

      let questionsTestLink = `${this.owQuestionsTestLink}${row.id_}`

      const surveyTypeIsNotCAWI = [SURVEY_TYPE.CATI, SURVEY_TYPE.CAPI].includes(
        row.survey_type,
      )

      if (surveyTypeIsNotCAWI) {
        questionsTestLink = `${questionsTestLink}?interview=y`
      }

      return window.open(questionsTestLink, '_blank')
    },

    turnLoadingOff() {
      this.loading = false
    },

    turnLoadingOn() {
      this.loading = true
    },

    turnExtraLoadingOff() {
      this.loadingMoreSurveys = false
    },

    turnExtraLoadingOn() {
      this.loadingMoreSurveys = true
    },

    turnSampleLoadingOff() {
      this.loadingSample = false
    },

    turnSampleLoadingOn() {
      this.loadingSample = true
    },

    capitalizeSurveyNames(surveys) {
      return surveys.map(({ name, ...rest }) => ({
        ...rest,
        name: this.capitalizeFirstLetter(name),
      }))
    },

    async loadExtraSurveys(startItem, group) {
      if (group !== this.groupName) return

      this.turnExtraLoadingOn()

      const loadData = await this.executeSurveyAPICall({
        path: 'survey/list',
        queryParams: { group, lastItem: JSON.stringify(startItem) },
      })

      if (!loadData) return this.turnExtraLoadingOff()

      const { surveys, lastItem } = loadData

      this.data = [...this.data, ...this.capitalizeSurveyNames(surveys)]

      if (lastItem) return this.loadExtraSurveys(lastItem, group)

      this.turnExtraLoadingOff()
    },

    async loadSurveys() {
      this.turnLoadingOn()

      const group = this.groupName

      const loadData = await this.executeSurveyAPICall({
        path: 'survey/list',
        queryParams: { group },
      })

      if (!loadData) return this.turnLoadingOff()

      const { surveys, lastItem } = loadData

      this.data = this.capitalizeSurveyNames(surveys)

      this.turnLoadingOff()

      if (lastItem) this.loadExtraSurveys(lastItem, group)
    },

    handleDrop(scope) {
      const widthWindow = window.innerWidth

      this.url = scope.row.test_link

      const menuItem = document.querySelector(`#menu${scope.row.id_}`)
      const drop = document.querySelector(`#drop${scope.row.id_}`)

      drop.classList.toggle('active')

      this.outsideClick(menuItem, ['click'], () => {
        drop.classList.remove('active')
      })

      if (widthWindow >= 1500) {
        drop.style.left = '85px'
      } else {
        drop.style.left = '-150px'
      }
    },
    outsideClick(element, events, callback) {
      const html = document.documentElement
      const outside = 'data-outside'
      if (!element.hasAttribute(outside)) {
        events.forEach(userEvent => {
          setTimeout(() => {
            html.addEventListener(userEvent, () => {
              if (!element.contains(event.target)) {
                element.removeAttribute(outside)
                events.forEach(userEvent => {
                  html.removeEventListener(userEvent, this.handleOutsideClick)
                })
                callback()
              }
            })
          })
        })
        element.setAttribute(outside, '')
      }
    },
  },

  created() {
    this.getGroups()
    this.loadSurveys()
  },
}
</script>

<style lang="scss" scoped>
.container {
  padding: 0 10px;
}

.activation-loader {
  display: inline-flex;
  align-items: center;
  margin-left: 20px;
}

.header {
  @include tipography(18);

  margin-top: 28px;
  font-weight: bold;

  display: flex;
  align-items: center;
  gap: 12px;

  .light & {
    color: $gray-6;
  }
}

.toggle {
  width: 43px;
  display: flex;
  position: relative;
  height: 20px;
  align-items: center;
  margin: 0 10px;
  padding: unset;
  padding-right: 20px;
  padding-left: 5px;
  padding-bottom: 1px;
  background: $gray-6;
  cursor: pointer;
  @include tipography(9);
  border: none;
  border-radius: 15px;
  transition: all 0.3s ease-in;
  &::after {
    content: '';
    display: block;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background: #48b2ff;
    box-shadow: 0px 0px 4px #0695fd;
    position: absolute;
    right: 3px;
    transition: all 0.2s ease-in;
  }
  &.left {
    padding-right: 6px;
    padding-left: 20px;
    &::after {
      background: $white;
      box-shadow: 0px 0px 2px white;
      right: unset;
      left: 3px;
    }
  }
  &:focus {
    outline: none;
  }
  .light & {
    background: $gray-light-2;
    color: $gray-8;
  }
}

.btn-survey {
  @include transparentButton;
  @include flexAlignCenter;
  cursor: pointer;
  @include tipography(16);

  &:disabled {
    @include disabled-button;
  }

  .content {
    @include flexMiddle;
    white-space: normal;
    word-break: break-all;
  }

  svg {
    @include boxSizing(15);
    margin-right: 8px;
  }

  &.edit {
    &.active {
      @include disabled-button;
    }
  }

  &.test-survey {
    svg {
      @include boxSizing(20);
    }

    &.disabled {
      @include disabled-button;
    }
  }

  &.sample-quotas {
    &.active {
      @include disabled-button;
    }
  }

  .light & {
    color: #696969;
  }
}

.btn-refresh {
  margin-right: 20px;
  border: none;
  background: none;
  cursor: pointer;
  width: 40px;
  height: 40px;
  .img-refresh {
    position: relative;
    top: unset;
    bottom: unset;
    right: unset;
    left: unset;
    width: 40px;
    height: 40px;
    bottom: 1px;
  }
  &:focus {
    outline: none;
  }
}

#group {
  @include tipography(16);
  color: $gray-5;
  background: none;
  border: 1px solid $gray-5;
  padding: 8px 10px;
  border-radius: 3px;
  &:focus {
    outline: none;
  }

  margin-right: 15px;
  color: $white;
  @include d(s) {
    margin-right: 0;
    width: 300px;
    margin-bottom: 20px;
  }

  option {
    color: $gray-6;
  }

  .light & {
    color: $gray-6;
  }
}

.menu-survey-table {
  @include flexMiddle;

  .menu {
    cursor: pointer;
    @include transparentButton;
    svg {
      @include boxSizing(30);
    }
  }
}

.menu-dropdown {
  display: none;
  position: absolute;
  bottom: 10px;
  right: 0px;
  min-width: 260px;
  background: $gray-7;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 2px;
  animation: growDown 400ms ease-in-out forwards;
  transform-origin: top center;

  button {
    width: 100%;
    @include tipography(15);
    cursor: pointer;
    background: none;
    border: none;
    outline: none;
    padding: 5px 10px;
    text-transform: uppercase;
    @include flexAlignCenter;

    &:hover {
      background: $gray-3;
    }

    svg {
      @include boxSizing(18);
      margin-right: 10px;
    }

    &.agentAndPartner {
      &.active {
        opacity: 0.5;
      }
    }
  }

  .light & {
    background: $white;
    button {
      color: $gray-6;

      &:hover {
        background: $gray-light-2;
      }
    }
  }

  &.active {
    display: block;
  }
}

.refreshSelect {
  display: flex;
  align-items: center;
}

.search {
  position: relative;

  .magnifier {
    position: absolute;
    right: 10px;
  }
}

@media (max-width: 767.98px) {
  .el-row .searchDatatable {
    .refreshSelect {
      display: flex;
      align-items: center;
      margin-bottom: 20px !important;
    }
    #group[data-v-01d29684] {
      margin-bottom: 0px;
    }
    display: block;
    justify-content: center;

    .search {
      position: relative;
      width: 300px;
    }
  }
}

@media (max-width: 968.98px) {
  .scroll {
    * {
      font-size: 13px;
    }
  }
  .toggle {
    font-size: 9px;
  }
  .menu-dropdown {
    * {
      font-size: 12px;
    }
  }
}

.scroll {
  margin-top: 24px;
}

@media (max-width: 1159px) {
  .scroll {
    padding-top: 20px;
    overflow-x: auto;

    &::-webkit-scrollbar {
      height: 10px;
    }
    &::-webkit-scrollbar-track {
      background: rgba(0, 0, 0, 0.2);
      border-radius: 10px;
    }
    &::-webkit-scrollbar-thumb {
      background: #215791;
      border-radius: 10px;
      width: 30px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: $secondary;
    }
  }
}

.first-loading-wrapper {
  margin-top: 24px;

  .shimmer {
    animation: shimmer 2s infinite;
    background: linear-gradient(to right, #eff1f3 4%, #e2e2e2 25%, #eff1f3 36%);
    background-size: 1000px 100%;
    height: 32px;
    border-radius: 4px;

    & + .shimmer {
      margin-top: 12px;
    }
  }

  @keyframes shimmer {
    0% {
      background-position: -1000px 0;
    }
    100% {
      background-position: 1000px 0;
    }
  }
}
</style>
